import { useCallback } from 'react'
import { driver } from 'driver.js'
import type { DriveStep } from 'driver.js'
import type { TourId } from './tourConfig'
import { TOURS } from './tourConfig'

/** Запускает шаги; шаги с отсутствующим в DOM элементом пропускаются. true, если что-то показано. */
export function runSteps(
  steps: DriveStep[],
  opts: { doneBtnText?: string; onDestroyed?: () => void } = {},
): boolean {
  const existingSteps = steps.filter((step) => {
    if (!step.element) return true
    return document.querySelector(step.element as string) !== null
  })
  if (existingSteps.length === 0) return false

  const driverObj = driver({
    showProgress: true,
    animate: true,
    overlayColor: 'rgba(0,0,0,0.45)',
    progressText: '{{current}} из {{total}}',
    nextBtnText: 'Далее →',
    prevBtnText: '← Назад',
    doneBtnText: opts.doneBtnText ?? 'Готово ✓',
    popoverClass: 'sup-ggp-tour',
    steps: existingSteps,
    onDestroyed: opts.onDestroyed,
  })
  driverObj.drive()
  return true
}

export function useTour() {
  const startTour = useCallback((tourId: TourId) => {
    const steps = TOURS[tourId]
    if (!steps || steps.length === 0) return
    runSteps(steps)
  }, [])

  return { startTour }
}
